﻿import controller from '../../../../Resources/Scripts/_Shared/Controller';
import { setSearchHistory } from '../../../../Resources/Scripts/_Shared/history';
import { calculateDistance } from '../../FacilitySearchPage/Scripts/Helpers'
//import { paramsToObject } from '../../../../Resources/Scripts/_Shared/history'

function campaignListPage(context) {
  //Filter
  const citySelect = context.querySelector(".campaignlistpage__filter--city select");
  const facilitySelect = context.querySelector(".campaignlistpage__filter--facility select");
  const filtersDisabled = context.dataset.disabled && context.dataset.disabled === 'true';
  const sortRadioButtons = context.querySelectorAll('.campaignlistpage__filters input[type="radio"]');
  const listItemsWrapper = context.querySelector(".campaignlistpage__list");

  if (!listItemsWrapper) return;

  const listItemsWrapperClone = listItemsWrapper.cloneNode(true);

  //Show more
  const style_element = document.createElement('STYLE');
  let listItems = listItemsWrapper?.childNodes ?? [];
  const button = context.querySelector('[data-load-more]');
  let observer;
  let buttonClick = false;
  let urlParams;
  let itemIncrement = 12;
  let itemsToShow;

  const disableLocationOption = () => {
    if (sessionStorage.getItem("userLocation")) return;
    sortRadioButtons[1].checked = false;
    sortRadioButtons[0].checked = true;
    sortRadioButtons[1].setAttribute('disabled', 'disabled');
  }
  function init() {
    if (!filtersDisabled) {
      sortRadioButtons.forEach(button => button.addEventListener('change', filter));
      citySelect.addEventListener('change', filter);
      facilitySelect.addEventListener('change', filter);
      window.addEventListener('load', filter);
    }

    urlParams = new URLSearchParams(window.location.search);
    itemsToShow = urlParams.get('items') ? parseInt(urlParams.get('items'), 10) : itemIncrement;
    listItemsWrapper.setAttribute('data-items', itemsToShow);

    if (listItems.length > itemIncrement) {
      button.addEventListener('click', function () {
        buttonClick = true;
        setTimeout(() => buttonClick = false, 250);

        itemsToShow = parseInt(itemsToShow, 10) + itemIncrement;
        listItemsWrapper.setAttribute('data-items', itemsToShow);
      });

      document.getElementsByTagName('HEAD')[0].appendChild(style_element);
      observer = new MutationObserver(observerCallback);
      observer.observe(listItemsWrapper, { attributes: true });
    }

    observerCallback();

    navigator.permissions
      .query({ name: "geolocation" })
      .then((permissionStatus) => {
        if (permissionStatus.state === 'denied') disableLocationOption();
        permissionStatus.onchange = () => {
          if (permissionStatus.state === 'denied') disableLocationOption();
          else sortRadioButtons[1].removeAttribute('disabled');
        };
      });
  }
  
  const getCoords = () => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject)
    })
  }

  const getUserLocation = async () => {
    const position = await getCoords()
      .catch(error => setTimeout(() => disableLocationOption(), 100))
    return { name: 'georesult', position: { lat: position?.coords?.latitude ?? null, lng: position?.coords?.longitude } ?? null };
  };
  
  async function filter() {
    const sortOrder = Array.from(sortRadioButtons).filter(button => button.checked)[0].value;
    const cityAttribute = citySelect.value.length === 0 ? '' : `[data-cities*="${citySelect.value}"]`;
    const facilityAttribute = facilitySelect.value.length === 0 ? '' : `[data-facilities*="${facilitySelect.value}"]`;
    const listItemsToSearch = listItemsWrapperClone.cloneNode(true);
    const listItemsContainingValue = listItemsToSearch.querySelectorAll(`li${cityAttribute}${facilityAttribute}`);

    const newItemList = [];

    for await (const item of listItemsContainingValue) {
      newItemList.push({ element: item, sortValue: await getSortValue(item, sortOrder) })
    };

    if ((sortOrder === 'distance' && sessionStorage.getItem("userLocation")) || sortOrder !== 'distance') {
      listItemsWrapper.innerHTML = '';
      sortAndAddElementsToContainer(newItemList, listItemsWrapper, sortOrder)
    }

    listItemsWrapper.setAttribute('data-items', 12);

    //const urlParams = new URLSearchParams(window.location.search);
    //urlParams.delete('c');
    //urlParams.delete('f');
    //urlParams.delete('s');
    //const city = citySelect.value;
    //const facility = facilitySelect.value;
    //const sort = Array.from(sortRadioButtons).filter(button => button.checked)[0].value;
    //if (city) urlParams.set('c', city);
    //if (facility) urlParams.set('f', facility);
    //if (sort) urlParams.set('s', sort);
    //const newUrl = location.origin + window.location.pathname + '?' + urlParams.toString();
    //history.pushState(paramsToObject(urlParams), document.title, newUrl);
  }

  async function getSortValue(element, sortOrder) {
    if (sortOrder === 'created') {
      return Date.parse(element.dataset.created);
    }
    else if (sortOrder === 'distance') {
      const userLocation = JSON.parse(sessionStorage.getItem("userLocation")) || await getUserLocation();
      if (userLocation.position.lat) sessionStorage.setItem("userLocation", JSON.stringify(userLocation))
      const facilityPositions = JSON.parse(element.dataset.facilityCoordinates);
      let shortestDistance = null;
      facilityPositions.forEach(position => {
        const distance = calculateDistance(
          { latitude: userLocation.position.lat, longitude: userLocation.position.lng },
          { latitude: position.lat, longitude: position.lng }
        )
        if (shortestDistance === null || distance < shortestDistance) shortestDistance = distance;
      });
      element.setAttribute('data-distance', shortestDistance)
      return shortestDistance;
    }
  }

  function sortAndAddElementsToContainer(arr, container, sortOrder) {
    let sortedList = sortArray(arr, sortOrder);
    for (var i = 0; i < sortedList.length; i++) {
      container.appendChild(sortedList[i].element);
    }
  }

  function sortArray(arr, sortOrder) {
    return arr.sort((a, b) => {
      return sortOrder === 'distance' ? (a.sortValue > b.sortValue ? 1 : -1) : (a.sortValue > b.sortValue ? -1 : 1);
    });
  }

  const observerCallback = function () {
    if (listItemsWrapper.dataset.items && parseInt(listItemsWrapper.dataset.items, 10) !== itemsToShow && !buttonClick) {
      itemsToShow = parseInt(listItemsWrapper.dataset.items, 10);
      setSearchHistory({ items: itemsToShow });
    }
    else if (itemsToShow !== itemIncrement) {
      setSearchHistory({ items: itemsToShow });
    }

    const itemsToShowStyle = itemsToShow + 1;
    const itemsToShowStyleAlt = (itemsToShow * 2) + 1;

    setVisibleStyle(`
      [data-list] > .campaignlistpage__listitem {
        display: block;
      }
      [data-list] > .campaignlistpage__listitem:nth-child(n + ${itemsToShowStyle}),
      [data-list] > .campaignlistpage__listitem:nth-child(n + ${itemsToShowStyleAlt}) {
        display: none;
      }
    `)

    if (itemsToShow >= listItemsWrapper.childElementCount)
      button.setAttribute('aria-hidden', 'true'), button.style.display = 'none';
    else
      button.removeAttribute('aria-hidden'), button.style.removeProperty('display');
  }

  const setVisibleStyle = function (css_text) {
    !!style_element.styleSheet ?
      style_element.styleSheet.cssText = css_text :
      style_element.innerHTML = css_text;
  }

  return {
    init
  };
}
controller.add('campaign-list-page', campaignListPage);